import { useEffect, useState } from "react";
import type { PillNodeAttrs } from "@smartsuite/smartdoc/lib/esm/extensions/pill/extension";
import type {
  OutputReference,
  ValueConfig,
} from "@smartsuite/automation-engine-api";
import { useRootStore } from "../../../../../../../../../stores/hooks";
import { useConverters } from "../../../../../../../../../utils/conditions-coverter.hook";
import { useLoopingMenu } from "../../../../../hooks/use-looping-menu";
import { CURRENT_ITEM_OUTPUT_ID } from "../../../../../../../../../utils/constants";
import type { ActionCandidate } from "../../../../../../../../../types/candidate";

interface ReferenceHook {
  pills: PillNodeAttrs[];
  getOutputRef: (ref: OutputReference) => PillNodeAttrs | undefined;
}

export const useReferenceHook = (
  config?: ValueConfig,
  action?: ActionCandidate,
): ReferenceHook => {
  const [pills, setPills] = useState<PillNodeAttrs[]>([]);
  const { automations } = useRootStore();
  const { candidate } = automations;
  const { trigger } = candidate.self;
  const timezone = candidate.getTimezone();
  const { loopingMenu } = useLoopingMenu({
    trigger,
    actions: candidate.allActions,
    integrations: [],
    types: [],
    ssFieldTypes: [],
    action,
  });

  const { valueConfigToTargetPills } = useConverters();

  useEffect(() => {
    if (config?.values !== undefined) {
      setPills(
        valueConfigToTargetPills(
          config,
          trigger,
          candidate.allActions,
          timezone,
          (label) => label,
          undefined,
          undefined,
          action,
          loopingMenu?.options,
        ),
      );
    }
  }, [config?.values.length]);

  const getOutputRef = (ref: OutputReference): PillNodeAttrs | undefined => {
    return pills.find((pill) => {
      const pillValue = JSON.parse(pill.value);
      return (
        pillValue.value === ref.outputId ||
        pillValue.outputId === CURRENT_ITEM_OUTPUT_ID
      );
    });
  };

  return { pills, getOutputRef };
};
